// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__1eJ4V","uploadButton":"index_uploadButton__2D5CL","uploadButton_tip":"index_uploadButton_tip__39Gm1","tip":"index_tip__3Ggid"};